import corner1 from 'assets/img/illustrations/corner-1.png';
import classNames from 'classnames';
import Background from 'components/common/Background';
import FalconCloseButton from 'components/common/FalconCloseButton';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import React, { useEffect, useState } from 'react';
import { Badge, Col, Modal, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import { useToast } from 'context/providers/ToastProvider';


const ModalOrdenesDeuda = ({
    idUsuario = 0,
    showModalOrdenesVencidas,
    setShowModalOrdenesVencidas 
}) => {

    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    //Columnas
    const columnsOrdenesDeudas = [
        {
            accessor: 'iNumPagosNoValidados',
            Header: '',
            cellProps: {
                className: 'py-2'
            },
            Cell: rowData => {
                const { iNumPagosNoValidados, idOrden, bComentario, dFechaOrden, dFechaPrimerPago } = rowData.row.original;
                return (
                    <>                        {iNumPagosNoValidados > 0 &&
                            <Link to={"/ordenes/detalle/" + idOrden}>
                                <img title="Hay pagos sin validar..." src="/img/advertencia20.png"></img>
                            </Link>
                        }

                        {bComentario == 1 &&
                            <img title="Hay comentarios" src="/img/comentario20.png"></img>
                        }
                        {dFechaPrimerPago < dFechaOrden &&
                            <Link to={"/ordenes/detalle/" + idOrden}>
                                <img title="Hay un error en este pago" src="/img/error20.png"></img>
                            </Link>

                        }
                    </>
                );
            }
        },
        {
            accessor: 'idOrden',
            Header: 'Orden',

            cellProps: {
                className: 'py-2'
            },
            Cell: rowData => {
                const { idOrden, vNombreCliente, vEmail, bIsActive, Estatus } = rowData.row.original;
                return (
                    <>
                        <Link to={"/ordenes/detalle/" + idOrden}>
                            <strong className={classNames({
                                "text-danger": bIsActive == false,
                            })}># {idOrden}</strong>
                        </Link>{'   '}&nbsp;&nbsp;&nbsp;
                        <Link to={"/ordenes/detalle/" + idOrden}>
                            <strong className={classNames({
                                "text-danger": bIsActive == false,
                            })}>{vNombreCliente}</strong> <br />
                        </Link>
                        <span className={classNames({
                            "text-danger": bIsActive == false,
                            "text-lowercase": true
                        })} >{vEmail}</span>
                        <div><Badge bg={Estatus == "Vencida" ? "danger" : "warning"} >{Estatus}</Badge></div>
                    </>
                );
            }
        },
        {
            accessor: '',
            Header: 'Fechas',
            Cell: rowData => {
                const { dFechaVenta, dFechaVencimiento } = rowData.row.original;
                return (
                    <>
                        <div className="text-700">
                            Fecha Venta
                        </div>
                        <div className="text-800 fw-bold">
                            {new Date(dFechaVenta).toLocaleDateString('es-mx', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' })}
                        </div>

                        <div className="text-700 mt-2">
                            Fecha Vencimiento
                        </div>
                        <div className="text-800 fw-bold">
                            {new Date(dFechaVencimiento).toLocaleDateString('es-mx', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' })}
                        </div>


                    </>
                );
            }
        },
        {
            accessor: 'vVendedor',
            Header: 'Vendedor',
            Cell: rowData => {
                const { vVendedor } = rowData.row.original;
                return (
                    <>
                        {vVendedor}

                    </>
                );
            }
        },

        {
            accessor: 'dTotal',
            Header: 'Total',
            Cell: rowData => {
                const { dTotal } = rowData.row.original;
                return (
                    <>
                        <span className="text-end fs--1 fw-medium py-2 fw-bold">${parseFloat(dTotal).toLocaleString("es-MX", {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2
                        })}</span>
                    </>
                );
            }
        },

        {
            accessor: 'dImportePagado',
            Header: 'Pagado',
            Cell: rowData => {
                const { dImportePagado } = rowData.row.original;
                return (
                    <>
                        <span className="text-end fs--1 fw-medium py-2 text-black fw-bold">${parseFloat(dImportePagado).toLocaleString("es-MX", {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2
                        })}</span>
                    </>
                );
            }
        },
        {
            accessor: 'dDeuda',
            Header: 'Insoluto',
            Cell: rowData => {
                const { dDeuda } = rowData.row.original;
                return (
                    <>
                        <span className="text-end fs--1 fw-medium py-2 text-danger fw-bold">${parseFloat(dDeuda).toLocaleString("es-MX", {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2
                        })}</span>
                    </>
                );
            }
        },
        {
            accessor: 'vMoneda',
            Header: 'Moneda',
            Cell: rowData => {
                const { vMoneda, dTipoCambio } = rowData.row.original;
                return (
                    <>
                        <span>

                            <span>{vMoneda}</span>
                            <span className="fw-bold">{(vMoneda == 'USD' ? " T.C. " + dTipoCambio : "")}</span>

                        </span>

                    </>
                );
            }
        },

    ];
    
    const [ordenesDeudas, setOrdenesDeudas] = useState([]);
    const ObtenerOrdenesConDeudas = async (idUsuario) => { 
        setShowModalOrdenesVencidas(false);
        const response = await fetch("/api/home/ObtenerOrdenesConDeuda?idUsuario=" + idUsuario, {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);
            });

        if (response.ok) {
            console.log("**********************ORDENES CON DEUDA**********************");
            console.log(response);
            const objResponse = await response.json();
            console.log(objResponse);
            if (objResponse.iResponseType == 1) {
                const data = JSON.parse(objResponse.detalles);
                console.log(data);
                setOrdenesDeudas(data);
                if (data.length > 0)
                    setShowModalOrdenesVencidas(true);
            }
            console.log("**********************ORDENES CON DEUDA**********************");
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    useEffect(() => {
        ObtenerOrdenesConDeudas(idUsuario);
    },[idUsuario])

    return (
        <>
            {
                showModalOrdenesVencidas &&
                <Modal
                    show={showModalOrdenesVencidas}
                    onHide={() => { setShowModalOrdenesVencidas(false); }}
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Background image={corner1} className="p-x1 bg-card" style={{ zIndex: 0 }} />
                    <Modal.Header >
                        <Modal.Title>
                            Órdenes con deudas
                        </Modal.Title>
                        <FalconCloseButton style={{ zIndex: 1 }} className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalOrdenesVencidas(false); }} />
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col className="col-12">
                                <Row>
                                    <Col>
                                        <AdvanceTableWrapper
                                            columns={columnsOrdenesDeudas}
                                            data={ordenesDeudas}
                                            sortable
                                            pagination
                                            perPage={6}
                                        >
                                            <AdvanceTable
                                                table
                                                headerClassName="bg-200 text-900 text-nowrap align-middle"
                                                rowClassName="align-middle white-space-nowrap"
                                                tableProps={{
                                                    size: 'sm',
                                                    striped: false,
                                                    className: 'fs--2 mb-0 overflow-hidden'
                                                }}
                                            />
                                            <AdvanceTableFooter
                                                rowCount={ordenesDeudas.length}
                                                table
                                                rowInfo
                                                navButtons
                                                rowsPerPageSelection
                                            />
                                        </AdvanceTableWrapper>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>

                    </Modal.Footer>
                </Modal>
            }
        </>
    );
};

ModalOrdenesDeuda.propTypes = {
    idUsuario: PropTypes.number,
    showModalOrdenesVencidas: PropTypes.bool,
    setShowModalOrdenesVencidas: PropTypes.func,
};


export default ModalOrdenesDeuda;